import {  useFormContext } from "react-hook-form";


import MultiSelectDropdown from "@/components/form-controls/MultiSelectDropDown";
import NumberInput from "@/components/form-controls/NumberInput";
import PhoneNumberInput from "@/components/form-controls/PhoneInput";
import RichTextEditor from "@/components/form-controls/RichTextEditor";
import TextInput from "@/components/form-controls/TextInput";
import {useGetLocation} from "@/features/applications/repositories/licences-repository.ts";
import {regions} from "@/constants/regions.ts";
import SelectInput from "@/components/form-controls/SelectInput.tsx";



export default function ProjectForm() {
    const { register,watch, formState: { errors }, clearErrors,control } = useFormContext()

    const { zones } = useGetLocation({});

    const getZones = zones?.results?.map((el: { name: any; }) => ({ label: el.name, value: el.name }));

    const getRegions = regions.map((el) => ({ label: el.name, value: el.name }));

    const getDistricts = (name?: string) => {
        let region = regions.find(el => el.name === name);
        if (region) return region.districts.map((el) => ({ label: el.name, value: el.name }));
        return [];
    };

    const getMunicipals = (regionName?: string, districtName?: string) => {
        let region = regions.find(el => el.name === regionName);
        if (region) {
            let district = region.districts.find(el => el.name === districtName);
            if (district) {
                return district.municipals.map((el) => ({ label: el, value: el }));
            }
        }
        return [];
    };

    const selectedRegion = watch("region");
    const selectedDistrict = watch("district");

    const handleInputBlur = (fieldName: string) => {
        if (errors[fieldName]) {
            clearErrors(fieldName);
        }
    }


    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">Project Details</h1>
            <p className="text-xs text-[#041528]">Outline the type of project you are investing in and its scope.</p>
            <div className="mt-5 grid grid-cols-1 gap-3 w-full pb-5">
                <div className="flex items-center w-full text-sm gap-3">

                    <TextInput
                        label="Project Name"
                        placeholder="What is the name of your project?"
                        onBlur={() => handleInputBlur("projectName")}
                        error={errors.projectName?.message?.toString()}
                        register={register("projectName", {
                            required: "Project name is required"
                        })}
                        className=" placeholder:font-extralight w-full"
                        required
                        
                    />

                    <TextInput
                        label="Project P.O. Box"
                        placeholder="Enter your project P.O. Box"
                        onBlur={() => handleInputBlur("projectPoBox")}
                        error={errors.projectName?.message?.toString()}
                        register={register("projectPoBox", {
                            required: "Project po box is required"
                        })}
                        className=" placeholder:font-extralight w-full"
                        required
                    />
                    
                </div>

                 <div className="flex items-center w-full text-sm gap-3">
                        <PhoneNumberInput
                            name="phoneNumber"
                            label="Phone Number"
                            placeholder="Enter your phoneNumber"
                            control={control}
                            required
                            className="w-full"
                        />

                        <TextInput
                            label="Email Address"
                            placeholder="e.g. mosha.peter@gmail.com"
                            type="email"
                            error={errors.emailAddress?.message?.toString()}
                            register={register("emailAddress",{
                                required: "Email address is required"
                            })}
                            required
                            className="w-full"
                        />
                 </div>

                <div className="flex items-center w-full text-sm gap-3">
                    <SelectInput
                        label="Zone"
                        displayName="label"
                        valueName="value"
                        options={getZones}
                        error={errors.zone?.message?.toString()}
                        register={register("zone", { required: "Zone is required" })}
                        required
                        className="w-full"
                    />

                    <SelectInput
                        label="Region"
                        displayName="label"
                        valueName="value"
                        error={errors.region?.message?.toString()}
                        options={getRegions}
                        register={register("region", { required: "Region is required" })}
                        required
                        className="w-full"
                    />

                </div>

                <div className="flex items-center w-full text-sm gap-3">
                    <SelectInput
                        label="District"
                        displayName="label"
                        valueName="value"
                        options={getDistricts(selectedRegion)}
                        error={errors.district?.message?.toString()}
                        register={register("district", { required: "District is required" })}
                        required
                        className="w-full"
                    />

                    <SelectInput
                        label="Municipal"
                        displayName="label"
                        valueName="value"
                        options={getMunicipals(selectedRegion, selectedDistrict)}
                        error={errors.municipal?.message?.toString()}
                        register={register("municipal", { required: "Municipal is required" })}
                        required
                        className="w-full"
                    />
                </div>
                
                <div className="flex items-center w-full text-sm gap-3">
                        
                    <TextInput
                        label="Street"
                        placeholder="Enter street"
                        onBlur={() => handleInputBlur("street")}
                        error={errors.street?.message?.toString()}
                        register={register("street", {
                            required: "Street is required"
                        })}
                        className="placeholder:font-extralight w-full "
                        required
                    />

                    <TextInput
                        label="Post Code"
                        placeholder="Enter post code"
                        onBlur={() => handleInputBlur("postCode")}
                        error={errors.postCode?.message?.toString()}
                        register={register("postCode",
                            {
                                required: "Post code is required"
                            }
                        )}
                        className="placeholder:font-extralight w-full"
                        required
                    />


                </div>

               


                    <TextInput
                        label="P.O. Box"
                        placeholder="Enter P.O. Box"
                        onBlur={() => handleInputBlur("poBox")}
                        error={errors.poBox?.message?.toString()}
                        register={register("poBox",
                            {
                                required: "P.O. Box is required"
                            }
                        )}
                        className="placeholder:font-extralight "
                        required
                    />

                {/* Project Type */}

                <div className="flex items-center w-full text-sm gap-3 ">
                    <span className="text-nowrap text-black font-semibold">Project Type</span>
                    <span className="border border-[#E3E7E8] w-full"/>
                </div>


                <MultiSelectDropdown
                    labelValue="Project Activities "
                    options={[
                        { label: "Accommodation", value: "accommodation" },
                        { label: "Services", value: "services" },]}
                    placeholder="Select accommodation services"
                    onChange={() => handleInputBlur("projectActivities")}
                    error={errors.projectActivities?.message?.toString()}
                    value={errors.projectActivities?.message?.toString()}
                    register={register("projectActivities", {
                        required: "Project activities is required",
                        valueAsNumber: true
                    })}
                    required
                />

                <NumberInput
                    label="If hosting guests, mention number of rooms"
                    placeholder="Enter number of rooms"
                    onBlur={() => handleInputBlur("numberOfRooms")}
                    error={errors.numberOfRooms?.message?.toString()}
                    register={register("numberOfRooms", {
                        required: "Number of rooms is required",
                        valueAsNumber: true
                    })}
                    required
                    className="relative"
                />

                <TextInput
                    label="Estimated Investment Amount"
                    placeholder="What is the estimated investment amount?"
                    onBlur={() => handleInputBlur("investMentAmount")}
                    error={errors.investMentAmount?.message?.toString()}
                    register={register("investMentAmount",{
                            required: "Estimated investment  is required",
                            valueAsNumber: true
                        }
                    )}
                    className="placeholder:font-extralight"
                    required
                />

                <RichTextEditor
                    name="projectDescription"
                    label="Describe your target market"
                    placeholder="Type here"
                />

            </div>
        </div>
    )
}